export enum BonusPayoutEnum {
  ContactFormEmailLabel = 'Adres e-mail',
  ContactFormMarketingConsent = 'Wyrażam zgodę na marketing',
  ContactFormMessageLabel = 'Wiadomość',
  ContactFormMessagePlaceholder = 'Wpisz szczegóły sprawy',
  ContactFormRegulationsConsent = 'Akceptuję regulamin serwisu Mubi',
  ContactFormSendButton = 'Wyślij wiadomość',
  ContactFormSubjectLabel = 'Temat',
  ContactFormSubjectNoPromotion = 'Brak akcji promocyjnej - odbiór bonusu',
  ContactFormSubjectVerificationFailed = 'Potwierdzenie danych - odbiór bonusu',
  ContactFormTitle = 'Napisz do nas',
  ContactSuccessSubtitle = 'Zgłoszenie zostało wysłane, odpowiemy najszybciej, jak to możliwe.',
  ContactSuccessTitle = 'Dziękujemy za kontakt!',
  FormFooter = 'Jeśli polisa została opłacona, bonus otrzymasz do 30&nbsp;dni od daty zgłoszenia.',
  FormSubtitle = 'Wprowadź informacje podane w\xa0trakcie zakupu polisy:',
  FormTitle = 'Odbierz bonus',
  FundraisingText = 'Podczas zakupu tej polisy został użyty kod TYMEK.\nKod Tymek nie uprawnia do odebrania bonusu, dzięki jego użyciu Mubi przekazało 100 zł na wsparcie budżetu wyścigowego Tymka Kucharczyka. Dziękujemy za użycie kodu TYMEK! Razem wspieramy Tymka!',
  FundraisingTitle = 'Bonus nie jest dostępny',
  LimitExceededText = 'Nie możemy przyznać kolejnej nagrody.',
  LimitExceededTitle = 'Limit bonusów został wykorzystany.',
  LoginAndGetLink = 'Zaloguj się i odbierz link',
  MiddleBoxHeading = 'Zacznij zarabiać z Mubi! 💸',
  MiddleBoxInfo1 = 'Przekaż link polecający swoim bliskim, a każdy z nich otrzyma 100 zł zwrotu po opłaceniu polisy.',
  MiddleBoxInfo2 = 'Z kolei Ty otrzymasz 100 zł za każdego nowego klienta!',
  MiddleBoxInfo3 = 'To proste! Możesz zdobyć w ten sposób nawet 2000 zł w ciągu roku.',
  NoPromotionActionLink = 'Skontaktuj się z nami',
  NoPromotionActionText = 'Na Twojej polisie nie ma przypisanego bonusu. Skontaktuj się z nami i napisz, z jakiej promocji chcesz skorzystać\xa0— pomożemy ustalić, co dalej.',
  RegistrationNumber = 'Numer rejestracyjny',
  SmsModalAttemptsExceeded = 'Przekroczono limit prób.',
  SmsModalCodeExpired = 'Kod wygasł.',
  SmsModalCodeLabel = 'Wpisz kod SMS',
  SmsModalCodeNotArrived = 'Kod nie dotarł?',
  SmsModalConfirm = 'Potwierdź',
  SmsModalDescription = 'W celu weryfikacji danych wpisz kod SMS wysłany na numer:',
  SmsModalMissingCode = 'Proszę wprowadzić kod SMS.',
  SmsModalResend = 'Wyślij kod ponownie',
  SmsModalResent = 'Wysłano ponownie',
  SmsModalSmsLimitExceeded = 'Przekroczono limit wysyłki SMS.',
  SmsModalSmsLimitHelp = 'Potrzebujesz pomocy? Zadzwoń: 22\xa022\xa010\xa0100',
  SmsModalSmsSendError = 'Nie udało się wysłać SMS.',
  SmsModalSmsSendErrorBody = 'Zweryfikuj numer telefonu lub zadzwoń 22\xa022\xa010\xa0100.',
  SmsModalTitle = 'Potwierdzenie SMS',
  SmsModalValidating = 'Weryfikacja kodu SMS...',
  SmsModalWrongCode = 'Kod nieprawidłowy',
  SmsModalWrongCodeBody = 'Spróbuj wprowadzić kod ponownie.',
  VerificationFailed1Text = 'Sprawdź, czy numer rejestracyjny i telefon są takie same jak przy zakupie polisy i spróbuj ponownie.',
  VerificationFailed1Title = 'Nie udało się zweryfikować danych.',
  VerificationFailed2Link = 'Skontaktuj się z nami',
  VerificationFailed2Subtitle = 'Jeśli wszystko się zgadza, zgłoś się do nas\xa0— sprawdzimy, czy bonus Ci przysługuje.',
  VerificationFailed2Title = 'Upewnij się, że podajesz numer rejestracyjny i telefon użyte przy zakupie polisy.',
}

export enum BonusPayoutVerificationAlertType {
  None = 'none',
  VerificationFailed1 = 'verificationFailed1',
  VerificationFailed2 = 'verificationFailed2',
  LimitExceeded = 'limitExceeded',
  NoPromotionAction = 'noPromotionAction',
  Fundraising = 'fundraising',
}

export enum BonusCaseEnum {
  ConfirmData = 'CONFIRM_DATA',
  NoPromotion = 'NO_PROMOTION',
}
